<template>
  <el-dialog
    title="角色管理"
    :visible.sync="showDialog"
    width="720px"
    :close-on-click-modal="false"
  >
    <el-transfer
      filterable
      v-loading="loading"
      :props="{ key: 'id', label: 'roleName' }"
      :filter-method="filterMethod"
      v-model="transferData.value"
      :titles="['未关联', '已关联']"
      :data="transferData.list"
      class="dialog-wrap"
    ></el-transfer>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showDialog = false">取 消</el-button>
      <el-button type="primary" @click="handlerTransfer" :loading="btnLoading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getRoleList, addUserRoles } from "@/api/account-management.js";
export default {
  props: {},
  data() {
    return {
      showDialog: false,
      transferData: {
        list: [],
        value: [],
      },
      curUserId: null,
      loading: false,
      btnLoading: false,
    };
  },
  methods: {
    showModal({ id, rolesId }) {
      this.curUserId = id;
      this.transferData.value = rolesId
        ? rolesId.split(",").map((stringNumber) => parseInt(stringNumber))
        : [];
      this.showDialog = true;
      this.selectDataList();
    },
    selectDataList() {
      this.transferData.list = [];
      this.loading = true;
      getRoleList({
        pageNum: 1,
        pageSize: 9999,
        isAll: true,
      }).then((res) => {
        if (res.code === "0000") {
          this.transferData.list = res.data.pageRoleInfo;
        }
        this.loading = false;
      });
    },
    handlerTransfer() {
      this.btnLoading = true;
      addUserRoles({
        userId: this.curUserId,
        roleIds: this.transferData.value.join(","),
      }).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "权限分配成功",
            type: "success",
          });
          this.$emit("refresh");
          this.showDialog = false;
        }
        this.btnLoading = false;
      });
    },
    filterMethod(value, option) {
      let searchSrt = value.toLowerCase();
      let dataStr =
        `${option.id}${option.roleName}${option.roleCode}`.toLowerCase();
      return dataStr.includes(searchSrt);
    },
  },
};
</script>

<style lang="less" scoped>
</style>
